export default function FormatDate(date: Date | string | null | undefined, delimiter: string = "/"): string {
  if (date) {
    if (typeof date === "string") {
      if (!isNaN(Date.parse(date))) {
        date = new Date(date)
      }
    }
    if (date instanceof Date) {
      return [
        ("0" + (date.getMonth() + 1)).slice(-2),
        ("0" + (date.getDate())).slice(-2),
        date.getFullYear(),
      ].join(delimiter)
    }
  }
  return ""
}

export function FormatDateAsLong(date: Date | string): string {
  if (date) {
    if (typeof date === "string") {
      if (!isNaN(Date.parse(date))) {
        date = new Date(date)
      }
    }
    if (date instanceof Date) {
      return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
    }
  }
  return ""
}

export function FormatShortDate(date: Date | string, suppressCurrentYear = false): string {
  if (date) {
    if (typeof date === "string") {
      if (!isNaN(Date.parse(date))) {
        date = new Date(date)
      }
    }
    if (date instanceof Date) {
      if (suppressCurrentYear && date.getFullYear() == new Date().getFullYear()) {
        return date.toLocaleDateString("en-US", { year: undefined, month: 'short', day: 'numeric' })
      } else {
        return date.toLocaleDateString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' })
      }
    }
  }
  return ""
}

export function FormatShortDateTime(date: Date | string): string {
  if (date) {
    if (typeof date === "string") {
      if (!isNaN(Date.parse(date))) {
        date = new Date(date)
      }
    }
    if (date instanceof Date) {
      return date.toLocaleDateString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
    }
  }
  return ""
}
